export const Environment = {
  lineLimit: 10,
  defaultSearchInput: 'Pesquisar...',
  emptyListInput: 'Nenhum registro encontrado.',
  isDevelopment: process.env.REACT_APP_ENV === 'development',
  baseUrl: process.env.REACT_APP_ENV === 'development'
    ? 'http://localhost:5000/'
    : 'https://api.sconapp.com.br/'
};